import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { theme } from '@adflow/frontend/ui-theme';

const styles = {
	radioButtonWrapper: css({ display: 'flex', maxWidth: '100%' }),
	radioButton: css({
		minWidth: 18,
		height: 18,
		width: 18,
		marginTop: 1,
		'&:disabled': css({ cursor: 'not-allowed' }),
		'&[readonly]': css({ cursor: 'default' }),

		accentColor: theme.colors.palettes.primary.main,
	}),
};

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
	containerStyle?: CSSInterpolation;
	className?: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
	function RadioRender({ className, containerStyle, children, ...props }, ref) {
		return (
			<div
				css={[styles.radioButtonWrapper, containerStyle]}
				className={className}
			>
				<input type="radio" ref={ref} css={styles.radioButton} {...props} />
				{children}
			</div>
		);
	}
);
